<template>
  <div v-if="!isDashboard" class="main-menu-grouping">
    <main-menu-grouping-desktop class="hidden-sm-and-down" />
    <main-menu-grouping-mobile class="hidden-md-and-up" />
  </div>
</template>

<script setup lang="ts">
import MainMenuGroupingDesktop from '@/views/layout/navigation/grouping/main-menu-grouping-desktop.vue';
import MainMenuGroupingMobile from '@/views/layout/navigation/grouping/main-menu-grouping-mobile.vue';
import { useUrl } from '@/composables';

const { isDashboard } = useUrl();
</script>
